export * from './accounts';
export * from './guidedRecipe';
export * from './identity';
export * from './recommendations';
export * from './session';

export const BASE_URL = `${process.env.NEXT_PUBLIC_ZAPIER_ORIGIN}/api/v4`;
